import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
const openPositionFloatyDisappear = () => {
    if(document.querySelector('.kirinus-float-contact__anchor')){
        let anchor = document.querySelector('.kirinus-float-contact__anchor');
        ScrollTrigger.create({
            trigger: '#stellenangebote',
            start: 'top bottom',
            endTrigger: 'body',
            end: 'bottom top',
            pinSpacing: false,
            onEnter: () => anchor.classList.add('d-none'),
            onLeaveBack: () => anchor.classList.remove('d-none'),
        })
    }
}
export default openPositionFloatyDisappear;